/**
 * GIF Compressor - /image/gif page
 */
import { createApp } from 'vue';
import GifCompressor from '@/Components/GifCompressor.vue';
import '@styles/app.css';

createApp(GifCompressor).mount('#gif-compressor');
